import { render } from "./template_updata.vue?vue&type=template&id=18121b80&scoped=true"
import script from "./template_updata.vue?vue&type=script&lang=js"
export * from "./template_updata.vue?vue&type=script&lang=js"

import "./template_updata.vue?vue&type=style&index=0&id=18121b80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18121b80"]])

export default __exports__